import { CheckCircleIcon, InformationCircleIcon, XCircleIcon } from '@heroicons/react/solid';
import { useSpring, animated, easings } from '@react-spring/web';
import { useReducer } from 'react';
import { createStore } from 'react-hooks-global-state';

export const ToastType = {
    right: "right",
    wrong: "wrong",
    info: "info",
    normal: "normal"
}

const ToastState = {
    showing: 1,
    shown: 2,
    hidding: 3,
    hid: 4
}

class Toast {
    id;
    text;//toast context
    type;//ToastType
    state;//ToastState
}

const ToastReducer = (state, action) => {
    switch (action.type) {
        case "add": {
            const { toasts } = state;
            return {
                ...state,
                toasts: [...toasts, action.value]
            };
        }
        case "update": {
            const { toasts } = state;
            const toast = action.value;
            for (let i = 0; i < toasts.length; i++) {
                if (toasts[i].id == toast.id) {
                    toasts[i] = toast;
                    break;
                }
            }
            return {
                ...state,
                toasts: [...toasts]
            };
        }
        case "remove": {
            const { toasts } = state;
            const toast = action.value;
            for (let i = 0; i < toasts.length; i++) {
                if (toasts[i].id == toast.id) {
                    toasts.splice(i, 1);
                }
            }
            return {
                ...state,
                toasts: [...toasts]
            };
        }
    }
}

let count = 0;

const { dispatch, useGlobalState } = createStore(ToastReducer, { toasts: [] })

export const useToast = () => {
    const [toasts] = useGlobalState('toasts')

    const makeToast = (text, type = ToastType.normal, id = null) => {
        const toast = new Toast();
        if (id == null) {
            toast.id = "toast_" + (++count);
        } else {
            toast.id = id;
        }
        toast.text = text;
        toast.type = type;
        toast.state = ToastState.showing
        toast.duration = 2
        toast.timeout = setTimeout(() => {
            toast.state = ToastState.hidding;
            dispatch({ type: "update", value: toast })
        }, toast.duration * 1000)

        let found = -1;
        for (let i = 0; i < toasts.length; i++) {
            if (toasts[i].id == toast.id) {
                found = i;
                break;
            }
        }

        if (found != -1) {
            clearTimeout(toasts[found].timeout);
            dispatch({ type: "update", value: toast })
        } else {
            dispatch({ type: "add", value: toast })
        }
    }

    return [makeToast]
}

export const ToastView = (props) => {
    const [toasts] = useGlobalState('toasts')

    let items = [];

    toasts.forEach(toast => {
        items.unshift(<ToastItem key={toast.id} toast={toast} />);
    });

    return <div className="flex flex-col fixed inset-0 z-20 pointer-events-none" >
        <div className='h-[60%]'></div>
        {items}
    </div>
}


const ToastItem = ({ toast }) => {

    let from = {};
    let to = {}
    if (toast.state == ToastState.showing) {
        from = { opacity: 0 }
        to = { opacity: 0.8 }
    } else if (toast.state == ToastState.hidding) {
        from = { opacity: 0.8 }
        to = { opacity: 0 }
    }

    const styles = useSpring({
        from: from,
        to: to,
        onStart: {
            opacity: () => {
            }
        },
        onRest: {
            opacity: () => {
                if (toast.state == ToastState.showing) {
                    toast.state = ToastState.shown;
                    dispatch({ type: "update", value: toast })
                } else if (toast.state == ToastState.hidding) {
                    toast.state = ToastState.hid;
                    dispatch({ type: "remove", value: toast })
                }
            }
        }
    })

    let icon = null;
    switch (toast.type) {
        case ToastType.right:
            icon = <CheckCircleIcon className='w-5 h-5 mr-1 text-clr-right' />
            break;
        case ToastType.wrong:
            icon = <XCircleIcon className='w-5 h-5 mr-1 text-clr-wrong' />
            break;
        case ToastType.info:
            icon = <InformationCircleIcon className='w-5 h-5 mr-1 text-link' />
            break;
    }

    return <div className='flex justify-center items-center'>
        <animated.div className="flex opacity-70 text-sm shadow-lg bg-gray-800 shadow-gray-600 justify-center items-center px-4 py-2 mb-2 rounded-lg  text-white"
            style={styles}
        >
            {icon}
            <div>{toast.text}</div>
        </animated.div>
    </div>
}